import { createSlice } from '@reduxjs/toolkit';
import { createExtraReducersForThunk, createApiThunkPrivate } from '../_helpers/ApiThunk';

const initialState = {
    getStateData: {}, getCountries: {}, getCitiesData: {}, getCountriesData: {}, getAppSettingsData: {},getAllCountryBanksWithCodeData:{}
}

export const getCountries = createApiThunkPrivate('getCountries', '/setting/countries', 'POST')
export const getState = createApiThunkPrivate('getState', '/setting/states', 'POST')
export const getCities = createApiThunkPrivate('getCities', '/setting/cities', 'POST')
export const getAppSettings = createApiThunkPrivate('getAppSettings', '/appSettings', 'GET')
export const updateAppSettings = createApiThunkPrivate('updateAppSettings', '/appSettings/update', 'POST')
export const getAllCountryBanksWithCode = createApiThunkPrivate('getAllCountryBanksWithCode', '/seller-store/country-bank-list', 'POST')

const settingSlice = createSlice({
    name: 'setting',
    initialState,
    extraReducers: builder => {
        createExtraReducersForThunk(builder, getCountries, 'getCountriesData')
        createExtraReducersForThunk(builder, getState, 'getStateData')
        createExtraReducersForThunk(builder, getCities, 'getCitiesData')
        createExtraReducersForThunk(builder, getAppSettings, 'getAppSettingsData')
        createExtraReducersForThunk(builder, getAllCountryBanksWithCode, 'getAllCountryBanksWithCodeData')
    }
})

export default settingSlice.reducer